import { Heading, SecondaryText, StyledFlex } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';
import { EmergencyNotificationButton } from '../../../trigger/EmergencyNotificationButton';

export const TestEmergencyNotificationButton = (): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={'8px'}>
         <StyledFlex direction={'column'}>
            <Heading
               testId={'testAlarmAndNotifications'}
               type={'h2'}
               content={translationKeys.testAlarmAndNotifications}
               margin={'0px'}
            />
            <SecondaryText
               testId={'clickButtonBelowToTriggerTestAlarmAndSendNotifications'}
               text={translationKeys.clickButtonBelowToTriggerTestAlarmAndSendNotifications}
            />
         </StyledFlex>

         <EmergencyNotificationButton variant={'test'} />
      </StyledFlex>
   );
};
